<template>
  <collapsible class="collapsible-scope-item" striped>
    <template #title>
      <p class="item-name">{{ scopeItem.name }}</p>
    </template>
    <template #subtitle>
      <div class="location-type-checkbox">
        <div class="location-type">
          <p class="location">Location: {{ scopeItem.location }}</p>
          <p class="type">
            Type: <span class="capitalize">{{ scopeItem.project_type }}</span>
          </p>
        </div>
        <div class="checkbox-container">
          <actions-cell
            :object="scopeItem"
            :actions="scopeItem.actions"
            class="inline mr-2"
          />
          <input
            :id="$id(`itemCompletion${scopeItem.id}`)"
            type="checkbox"
            @click.stop
            @change="changeItemStatus"
            v-model="scopeItem.pivot.is_completed"
          />
          <label :for="$id(`itemCompletion${scopeItem.id}`)" @click.stop
            >Completed</label
          >
        </div>
      </div>
    </template>
    <template #content>
      <div class="item-container">
        <template v-if="$mq === 'sm'">
          <scope-item-task-cell
            :task="scopeItemTask"
            :key="`scope_item_task_${i}`"
            v-for="(scopeItemTask, i) in scopeItem.tasks"
          />
        </template>

        <bdg-table-view
          :rows="scopeItem.tasks"
          :columns="columns"
          alternate-striped
          v-else
        >
        </bdg-table-view>
        <div class="add-task-control" @click="addTask">
          <i class="far fa-plus-square text-xl text-red" />
          <span class="ml-2">Add Task</span>
        </div>
      </div>
    </template>
  </collapsible>
</template>

<script>
import Collapsible from "../../elements/Collapsible";
import BdgTableView from "../../elements/table-view/BdgTableView";
import ScopeItemTaskCell from "../../elements/list-view/list-view-cells/contract-cells/ScopeItemTaskCell";
import FilesListCell from "../../elements/table-view/special-cells/FilesListCell";
import CheckboxCell from "../../elements/table-view/special-cells/CheckboxCell";
import ScopeItemTaskForm from "../../views/contracts/forms/ScopeItemTaskForm";
import GenericDeleteModal from "../modals/GenericDeleteModal";
import ActionsCell from "@/elements/table-view/special-cells/ActionsCell";

export default {
  name: "CollapsibleScopeItem",
  components: { ScopeItemTaskCell, BdgTableView, Collapsible, ActionsCell },
  props: {
    scopeItem: Object
  },
  data() {
    return {
      contractId: parseInt(this.$route.params.id, 10),
      columns: [
        { label: "Task Name", property: "name" },
        { label: "Assigned To", property: "userName" },
        { label: "Scheduled", property: "scheduledDate" },
        {
          label: "Priority",
          property: "priority",
          additionalCellClasses: "capitalize"
        },
        { label: "Description", property: "description" },
        {
          label: "Attached Files",
          property: "nestedFiles",
          cellComponent: FilesListCell
        },
        {
          label: "Completion",
          property: "completionCheckboxInfo",
          cellComponent: CheckboxCell
        },
        {
          label: "Actions",
          property: "actions",
          actions: [
            {
              label: "edit",
              clickAction: task => {
                this.$store.commit("setCreateEditComponentParams", {
                  createEditComponent: ScopeItemTaskForm,
                  createEditComponentData: {
                    ...task,
                    scopeItemName: this.scopeItem.name
                  },
                  createEditComponentIsShown: true
                });
              }
            },
            {
              label: "delete",
              clickAction: task => {
                this.$store.commit("setConfirmationModalParams", {
                  type: "delete",
                  headerText: "Delete Confirmation",
                  bodyComponent: GenericDeleteModal,
                  bodyComponentData: {
                    entityName: "task",
                    deleteFunction: () =>
                      this.$store.dispatch("deleteContractScopeItemTask", task)
                  },
                  isShown: true
                });
              }
            }
          ]
        }
      ]
    };
  },
  methods: {
    changeItemStatus() {
      const bool = this.scopeItem.pivot.is_completed;
      this.$store.dispatch("updateContractScopeItemStatus", {
        ...this.scopeItem,
        contract_id: this.contractId,
        status: bool ? "completed" : "not-started"
      });
    },
    addTask() {
      this.$store.commit("setCreateEditComponentParams", {
        createEditComponent: ScopeItemTaskForm,
        createEditComponentData: {
          scopeItemName: this.scopeItem.name,
          work_scope_id: this.scopeItem.work_scope_id,
          work_scope_item_id: this.scopeItem.id
        },
        createEditComponentIsShown: true
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.item-container {
  padding: 5px 15px;
  border-left: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
}
.collapsible-scope-item {
  .title {
    .main {
      .item-name {
        @screen md {
          @apply relative w-1/5 mr-4;

          &:after {
            content: "";
            position: absolute;
            top: -1rem;
            right: 0;

            width: 1px;
            height: calc(100% + 2rem);

            @apply bg-lightgray;
          }
        }
      }

      .location-type-checkbox {
        @apply flex justify-between items-center mt-3;

        @screen md {
          @apply flex-grow mt-0;
        }

        .location-type {
          @screen md {
            @apply flex-grow flex mr-4;
          }

          .location,
          .type {
            @screen md {
              @apply w-1/4;
            }
          }

          .location {
            @screen md {
              @apply mr-4;
            }
          }
        }

        .checkbox-container {
          @screen md {
            @apply mr-20;
          }
        }
      }
    }
  }
  .content {
    .add-task-control {
      @apply flex justify-center items-center pt-3 pb-3 px-4 uppercase cursor-pointer;

      @screen md {
        @apply justify-start pb-6;
      }
    }
  }
}
</style>
